// src/components/common/ConsentBanner.tsx
"use client";

import React from 'react';

const KEY = 'juicystarz-consent';

export default function ConsentBanner() {
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    try {
      const v = localStorage.getItem(KEY);
      if (!v) setVisible(true);
    } catch {}
  }, []);
  if (!visible) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[10000]">
      <div className="mx-auto max-w-4xl m-3 border rounded-md bg-background text-foreground shadow p-3 text-sm">
        <p>
          We use cookies to personalize content and analyze our traffic. By continuing, you agree to our cookie policy.
        </p>
        <div className="mt-2 flex items-center gap-2 justify-end">
          <button
            className="px-3 py-1 rounded border"
            onClick={() => setVisible(false)}
            aria-label="Dismiss"
          >
            Dismiss
          </button>
          <button
            className="px-3 py-1 rounded border bg-primary text-primary-foreground"
            onClick={() => { try { localStorage.setItem(KEY, '1'); } catch {}; setVisible(false); }}
            aria-label="Accept"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

